import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartRenderer = ({ chartConfig, data = [] }) => {
    const options = useMemo(() => {
        if (!chartConfig || !data.length) {
            return null;
        }

        if (chartConfig.options) {
            return chartConfig.options;
        }

        const chartType = (chartConfig.chartType || 'column').toLowerCase();
        const xField = chartConfig.xAxis || chartConfig.xField || chartConfig.xAxisField;
        const yField = chartConfig.yAxis || chartConfig.yField || chartConfig.yAxisField;

        if (!xField || !yField) {
            return null;
        }

        const categories = data.map((row) => row[xField] ?? '');
        const seriesData = data.map((row) => Number(row[yField]) || 0);

        return {
            chart: { type: chartType },
            title: { text: chartConfig.title || '' },
            credits: { enabled: false },
            xAxis: { categories },
            yAxis: { title: { text: yField } },
            series: [{ name: chartConfig.title || yField, data: seriesData }],
        };
    }, [chartConfig, data]);

    if (!options) {
        return null;
    }

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ChartRenderer;
